'use client';
import { isBrowser } from '@s7/platform';

var getScrollStart = function(param) {
    var axis = param.axis, parent = param.parent;
    if (!parent && !isBrowser()) {
        return 0;
    }
    var method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) {
        return parent[method];
    }
    var body = document.body, documentElement = document.documentElement;
    return body[method] + documentElement[method];
};

export { getScrollStart };
